<template>
  <div>
    <b-table
      id="user-table"
      class="px-1 rounded mt-2 bg-light-secondary"
      :tbody-tr-class="['tableRowClass']"
      small
      :fields="fields"
      :items="GET_ISNTRUMENTS_REMAINS_BUILDERS.results"
      show-empty
      responsive
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>
      <template #cell(category)="{ item }">
        <span v-if="item.type.category && item.type.category.title">
          {{ item.type.category.title }}
        </span>
      </template>

      <template #cell(actions)="props">
        <div class="d-flex align-items-center">
          <b-button
            v-if="checkButtonPermission(['builder'])"
            @click="returnItems(props.item)"
            size="sm"
            variant="warning"
            class="d-block ml-50"
          >
            {{$t('return')}}
          </b-button>
        </div>
      </template>
    </b-table>

    <returnModal
      :item="data_item"
      :type="true"
      @reload="FETCH_INSTRUMENTS_REMAINS_BUILDERS"
    />
  </div>
</template>

<script>
import { BButton, BTable, BCard } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import check from "@/mixins/check";
import returnModal from "../returnModal.vue";

export default {
  components: {
    BTable,
    BButton,
    BCard,
    returnModal,
  },
  data: () => ({
    item: null,
    card: true,
    data_item: null,
    fields: [
      {
        label: "№",
        key: "id",
        thClass: "tableHeadClass",
      },
      {
        label: "reference.categoriya",
        key: "category",
        thClass: "tableHeadClass",
      },
      {
        label: "courses.type",
        key: "type.title",
        thClass: "tableHeadClass",
      },

      {
        label: "reference.name",
        key: "title",
        thClass: "tableHeadClass",
      },

      {
        label: "amount",
        key: "total_count",
        thClass: "tableHeadClass",
      },
      {
        label: "master",
        key: "master",
        thClass: "tableHeadClass",
      },
      {
        label: "object",
        key: "object_title",
        thClass: "tableHeadClass",
      },
      {
        label: "actions",
        key: "actions",
        thClass: "tableHeadClass",
        tdClass: "d-flex justify-content-center",
      },
    ],
  }),
  mixins: [check],
  computed: {
    ...mapGetters("materials", ["GET_MATERIALS_FOR_BUILDERS"]),
    ...mapGetters("instruments", ["GET_ISNTRUMENTS_REMAINS_BUILDERS"]),
  },
  methods: {
    ...mapActions("instruments", ["FETCH_INSTRUMENTS_REMAINS_BUILDERS"]),

    returnItems(data) {
      this.data_item = data;
      this.$nextTick(() => {
        this.$bvModal.show("return-modal");
      });
    },
  },
};
</script>

<style lang="scss">
#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}
</style>
